<template>
	<div class="detail-wrapper">
		<div class="header">
			<div class="header-title">
				<span class="back" @click="fallback">
					<i class="iconfont">&#xe613;</i>
				</span>
				<span class="title">数据详细报表</span>
			</div>
		    <div class="header-select">
		    	<awesome-picker
			      	ref="DetailSelect"
			      	:data="picker.data"
			      	:textTitle="picker.textTitle"
			      	:anchor="picker.anchor"
			      	@confirm="handleDetail"
			    >
			    </awesome-picker>
			    <div class="select-wrapper" @click="detailShow">
			    	<span class="select">
			    		{{nowDate}}
			    	</span>
			    	<span class="icon-wrapper">
			    		<i class="iconfont select-icon">&#xe61c;</i>
			    	</span>
		    	</div>
	        </div>
		</div>
		<div class="contant-wrapper" ref="detailScroll">
			<div>
				<div class="desc-wrap" :class="[progress > 0 ? 'desc-c' : 'desc-l' ]">
					<p class="title">{{limitDate}}</p>
					<div class="content">
						<span class="desc">{{progress > 0 ? '+' + progress : progress}}</span>
						<span class="text">完成进度</span>
					</div>
				</div>
				<ul class="detail-list">
					<li class="list-item">
						<div class="item-head">
							<span class="text">
								<i class="iconfont icon-round">&#xe7ae;</i>到诊
							</span>
							<span class="number">
								<span class="col">{{dz_total_curr}}/</span>{{dz_total_plan}}
							</span>
							<span class="state" v-show="isShow" :class="{active: dz_total_curr >= dz_total_plan}">{{dz_state}}</span>
						</div>
						<div class="item-content">
							<div class="type">
								<p class="number">
									{{dz_jj_plan}}
									<span
										class="tips"
										:class="[dz_jj_diff > 0 ? 'rise' : 'glide']"
										v-show="dz_jj_diff != 0"
									>
										{{dz_jj_diff}}
									</span>
								</p>
								<p class="text">竞价</p>
							</div>
							<div class="type">
								<p class="number">
									{{dz_yh_plan}}
									<span
										class="tips"
										:class="[dz_yh_diff > 0 ? 'rise' : 'glide']"
										v-show="dz_yh_diff != 0"
									>
									{{dz_yh_diff}}
								</span>
								</p>
								<p class="text">优化</p>
							</div>
							<div class="type">
								<p class="number">
									{{dz_mh_plan}}
									<span
										class="tips"
										:class="[dz_mh_diff > 0 ? 'rise' : 'glide']"
										v-show="dz_mh_diff != 0"
									>
										{{dz_mh_diff}}
									</span>
								</p>
								<p class="text">门户</p>
							</div>
							<div class="type">
								<p class="number">
									{{dz_xmt_plan}}
									<span
										class="tips"
										:class="[dz_xmt_diff > 0 ? 'rise' : 'glide']"
										v-show="dz_xmt_diff != 0"
									>
										{{dz_xmt_diff}}
									</span>
								</p>
								<p class="text">新媒体</p>
							</div>
								<div class="type">
								<p class="number">
									{{dz_zyhz_plan}}
									<span
										class="tips"
										:class="[dz_zyhz_diff > 0 ? 'rise' : 'glide']"
										v-show="dz_zyhz_diff != 0"
									>
										{{dz_zyhz_diff}}
									</span>
								</p>
								<p class="text">资源合作</p>
							</div>
								<div class="type">
								<p class="number">
									{{dz_wgj_plan}}
									<span
										class="tips"
										:class="[dz_wgj_diff > 0 ? 'rise' : 'glide']"
										v-show="dz_wgj_diff != 0"
									>
										{{dz_wgj_diff}}
									</span>
								</p>
								<p class="text">无轨迹</p>
							</div>
							<div class="type">
								<p class="number">
									{{dz_qt_plan}}
									<span
										class="tips"
										:class="[dz_qt_diff > 0 ? 'rise' : 'glide']"
										v-show="dz_qt_diff != 0"
									>
										{{dz_qt_diff}}
									</span>
								</p>
								<p class="text">其他</p>
							</div>
						</div>
					</li>
					<!-- 对话-->
					<li class="list-item">
						<div class="item-head">
							<span class="text">
								<i class="iconfont icon-round">&#xe641;</i>对话
							</span>
							<span class="number">
								<span class="col">{{dh_total_curr}}/</span>{{dh_total_plan}}
							</span>
							<span class="state" v-show="isShow" :class="{active: dh_total_curr >= dh_total_plan}">{{dh_state}}</span>
						</div>
						<div class="item-content">
							<div class="type">
								<p class="number">
									{{dh_jj_plan}}
									<span
										class="tips"
										:class="[dh_jj_diff > 0 ? 'rise' : 'glide']"
										v-show="dh_jj_diff != 0"
									>
										{{dh_jj_diff}}
									</span>
								</p>
								<p class="text">竞价</p>
							</div>
							<div class="type">
								<p class="number">
									{{dh_yh_plan}}
									<span
										class="tips"
										:class="[dh_yh_diff > 0 ? 'rise' : 'glide']"
										v-show="dh_yh_diff != 0"
									>
										{{dh_yh_diff}}
									</span>
								</p>
								<p class="text">优化</p>
							</div>
							<div class="type">
								<p class="number">
									{{dh_mh_plan}}
									<span
										class="tips"
										:class="[dh_mh_diff > 0 ? 'rise' : 'glide']"
										v-show="dh_mh_diff != 0"
									>
										{{dh_mh_diff}}
									</span>
								</p>
								<p class="text">门户</p>
							</div>

							<div class="type">
								<p class="number">
									{{dh_xmt_plan}}
									<span
										class="tips"
										:class="[dh_xmt_diff > 0 ? 'rise' : 'glide']"
										v-show="dh_xmt_diff != 0"
									>
										{{dh_xmt_diff}}
									</span>
								</p>
								<p class="text">新媒体</p>
							</div>
							<div class="type">
								<p class="number">
									{{dh_zyhz_plan}}
									<span
										class="tips"
										:class="[dh_zyhz_diff > 0 ? 'rise' : 'glide']"
										v-show="dh_zyhz_diff != 0"
									>
										{{dh_zyhz_diff}}
									</span>
								</p>
								<p class="text">资源合作</p>
							</div>
							<div class="type">
								<p class="number">
									{{dh_wgj_plan}}
									<span
										class="tips"
										:class="[dh_wgj_diff > 0 ? 'rise' : 'glide']"
										v-show="dh_wgj_diff != 0"
									>
										{{dh_wgj_diff}}
									</span>
								</p>
								<p class="text">无轨迹</p>
							</div>
							<div class="type">
								<p class="number">
									{{dh_qt_plan}}
									<span
										class="tips"
										:class="[dh_qt_diff > 0 ? 'rise' : 'glide']"
										v-show="dh_qt_diff != 0"
									>
										{{dh_qt_diff}}
									</span>
								</p>
								<p class="text">其他</p>
							</div>
						</div>
					</li>
					<!--  确认对话-->
					<li class="list-item">
						<div class="item-head">
							<span class="text">
								<i class="iconfont icon-round">&#xe641;</i>确诊对话
							</span>
							<span class="number">
								<span class="col">{{sure_dh_total_curr}}/</span>{{sure_dh_total_plan}}
							</span>
							<span class="state" v-show="isShow" :class="{active: sure_dh_total_curr >= sure_dh_total_plan}">{{sure_dh_state}}</span>
						</div>
						<div class="item-content">
							<div class="type">
								<p class="number">
									{{sure_dh_jj_plan}}
									<span
										class="tips"
										:class="[sure_dh_jj_diff > 0 ? 'rise' : 'glide']"
										v-show="sure_dh_jj_diff != 0"
									>
										{{sure_dh_jj_diff}}
									</span>
								</p>
								<p class="text">竞价</p>
							</div>
							<div class="type">
								<p class="number">
									{{sure_dh_yh_plan}}
									<span
										class="tips"
										:class="[sure_dh_yh_diff > 0 ? 'rise' : 'glide']"
										v-show="sure_dh_yh_diff != 0"
									>
										{{sure_dh_yh_diff}}
									</span>
								</p>
								<p class="text">优化</p>
							</div>
							<div class="type">
								<p class="number">
									{{sure_dh_mh_plan}}
									<span
										class="tips"
										:class="[sure_dh_mh_diff > 0 ? 'rise' : 'glide']"
										v-show="sure_dh_mh_diff != 0"
									>
										{{sure_dh_mh_diff}}
									</span>
								</p>
								<p class="text">门户</p>
							</div>

							<div class="type">
								<p class="number">
									{{sure_dh_xmt_plan}}
									<span
										class="tips"
										:class="[sure_dh_xmt_diff > 0 ? 'rise' : 'glide']"
										v-show="sure_dh_xmt_diff != 0"
									>
										{{sure_dh_xmt_diff}}
									</span>
								</p>
								<p class="text">新媒体</p>
							</div>
							<div class="type">
								<p class="number">
									{{sure_dh_zyhz_plan}}
									<span
										class="tips"
										:class="[sure_dh_zyhz_diff > 0 ? 'rise' : 'glide']"
										v-show="sure_dh_zyhz_diff != 0"
									>
										{{sure_dh_zyhz_diff}}
									</span>
								</p>
								<p class="text">资源合作</p>
							</div>
							<div class="type">
								<p class="number">
									{{sure_dh_wgj_plan}}
									<span
										class="tips"
										:class="[sure_dh_wgj_diff > 0 ? 'rise' : 'glide']"
										v-show="sure_dh_wgj_diff != 0"
									>
										{{sure_dh_wgj_diff}}
									</span>
								</p>
								<p class="text">无轨迹</p>
							</div>
							<div class="type">
								<p class="number">
									{{sure_dh_qt_plan}}
									<span
										class="tips"
										:class="[sure_dh_qt_diff > 0 ? 'rise' : 'glide']"
										v-show="sure_dh_qt_diff != 0"
									>
										{{sure_dh_qt_diff}}
									</span>
								</p>
								<p class="text">其他</p>
							</div>
						</div>
					</li>
					<!-- 预算-->
					<li class="list-item">
						<div class="item-head">
							<span class="text">
								<i class="iconfont icon-round">&#xe6a4;</i>预算
							</span>
							<span class="number">
								<span class="col">{{ys_total_curr}}/</span>{{ys_total_plan}}元
							</span>
							<span class="state" v-show="isShow" :class="[ys_total_curr <=　ys_total_plan ? 'active' : 'active-color']">{{ys_state}}</span>
						</div>
						<div class="item-content">
							<div class="type">
								<p class="number" :class="{active: ys_jj_diff > 0}">
									{{ys_jj_curr}}
								</p>
								<p class="text">竞价</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: ys_yh_diff > 0}">
									{{ys_yh_curr}}
								</p>
								<p class="text">优化</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: ys_mh_diff > 0}">
									{{ys_mh_curr}}
								</p>
								<p class="text">门户</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: ys_xmt_diff > 0}">
									{{ys_xmt_curr}}
								</p>
								<p class="text">新媒体</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: ys_zyhz_diff > 0}">
									{{ys_zyhz_curr}}
								</p>
								<p class="text">资源合作</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: ys_wgj_diff > 0}">
									{{ys_wgj_curr}}
								</p>
								<p class="text">无轨迹</p>
							</div>
							<div class="type" :class="{active: ys_qt_diff > 0}">
								<p class="number">
									{{ys_qt_curr}}
								</p>
								<p class="text">其他</p>
							</div>
						</div>
					</li>
					<!-- 对话成本-->
					<li class="list-item">
						<div class="item-head">
							<span class="text">
								<i class="iconfont icon-round">&#xe69d;</i>对话成本
							</span>
							<span class="number">
								<span class="col">{{cb_dh_total_curr}}/</span>{{cb_dh_total_plan}}(元/条)
							</span>
							<span class="state" v-show="isShow" :class="[cb_dh_total_curr <= cb_dh_total_plan ? 'active' : 'active-color']">{{dh_base_state}}</span>
						</div>
						<div class="item-content">
							<div class="type">
								<p class="number" :class="{active: dh_jj_base_diff > 0}">
									{{dh_jj_base}}
								</p>
								<p class="text">竞价</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dh_yh_base_diff > 0}">
									{{dh_yh_base}}
								</p>
								<p class="text">优化</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dh_mh_base_diff > 0}">
									{{dh_mh_base}}
								</p>
								<p class="text">门户</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dh_xmt_base_diff > 0}">
									{{dh_xmt_base}}
								</p>
								<p class="text">新媒体</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dh_zyhz_base_diff > 0}">
									{{dh_zyhz_base}}
								</p>
								<p class="text">资源合作</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dh_wgj_base_diff > 0}">
									{{dh_wgj_base}}
								</p>
								<p class="text">无轨迹</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dh_qt_base_diff > 0}">
									{{dh_qt_base}}
								</p>
								<p class="text">其他</p>
							</div>
						</div>
					</li>
					<!-- 到诊成本-->
					<li class="list-item">
						<div class="item-head">
							<span class="text">
								<i class="iconfont icon-round">&#xe69d;</i>到诊成本
							</span>
							<span class="number">
								<span class="col">{{cb_dz_total_curr}}/</span>{{cb_dz_total_plan}}(元/条)
							</span>
							<span class="state" v-show="isShow" :class="[cb_dz_total_curr <= cb_dz_total_plan ? 'active' : 'active-color']">{{dz_base_state}}</span>
						</div>
						<div class="item-content">
							<div class="type">
								<p class="number" :class="{active: dz_jj_base_diff > 0}">
									{{dz_jj_base}}
								</p>
								<p class="text">竞价</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_yh_base_diff > 0}">
									{{dz_yh_base}}
								</p>
								<p class="text">优化</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_mh_base_diff > 0}">
									{{dz_mh_base}}
								</p>
								<p class="text">门户</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_xmt_base_diff > 0}">
									{{dz_xmt_base}}
								</p>
								<p class="text">新媒体</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_zyhz_base_diff > 0}">
									{{dz_zyhz_base}}
								</p>
								<p class="text">资源合作</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_wgj_base_diff > 0}">
									{{dz_wgj_base}}
								</p>
								<p class="text">无轨迹</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_qt_base_diff > 0}">
									{{dz_qt_base}}
								</p>
								<p class="text">其他</p>
							</div>
						</div>
					</li>
					<!--  确诊对话成本-->
					<li class="list-item">
						<div class="item-head">
							<span class="text">
								<i class="iconfont icon-round">&#xe69d;</i>确诊对话成本
							</span>
							<span class="number">
								<span class="col">{{cb_sure_dh_total_curr}}/</span>{{cb_sure_dh_total_plan}}(元/条)
							</span>
							<span class="state" v-show="isShow" :class="[cb_sure_dh_total_curr <= cb_sure_dh_total_plan ? 'active' : 'active-color']">{{sure_dh_base_state}}</span>
						</div>
						<div class="item-content">
							<div class="type">
								<p class="number" :class="{active: sure_dh_jj_base_diff > 0}">
									{{sure_dh_jj_base}}
								</p>
								<p class="text">竞价</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_yh_base_diff > 0}">
									{{sure_dh_yh_base}}
								</p>
								<p class="text">优化</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_mh_base_diff > 0}">
									{{sure_dh_mh_base}}
								</p>
								<p class="text">门户</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_xmt_base_diff > 0}">
									{{sure_dh_xmt_base}}
								</p>
								<p class="text">新媒体</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_zyhz_base_diff > 0}">
									{{sure_dh_zyhz_base}}
								</p>
								<p class="text">资源合作</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_wgj_base_diff > 0}">
									{{sure_dh_wgj_base}}
								</p>
								<p class="text">无轨迹</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_qt_base_diff > 0}">
									{{sure_dh_qt_base}}
								</p>
								<p class="text">其他</p>
							</div>
						</div>
					</li>
					<!--  到诊转化率-->
					<li class="list-item">
						<div class="item-head">
							<span class="text">
								<i class="iconfont icon-round">&#xe69d;</i>到诊转化率
							</span>
							<!-- <span class="number">
								<span class="col">{{cb_dz_total_curr}}/</span>{{cb_dz_total_plan}}(元/条)
							</span>
							<span class="state" v-show="isShow" :class="[cb_dz_total_curr <= cb_dz_total_plan ? 'active' : 'active-color']">{{dz_base_state}}</span> -->
						</div>
						<div class="item-content">
							<div class="type">
								<p class="number" :class="{active: dz_jj_rate_diff > 0}">
									{{dz_jj_rate}} %
								</p>
								<p class="text">竞价</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_yh_rate_diff > 0}">
									{{dz_yh_rate}} %
								</p>
								<p class="text">优化</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_mh_rate_diff > 0}">
									{{dz_mh_rate}} %
								</p>
								<p class="text">门户</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_xmt_rate_diff > 0}">
									{{dz_xmt_rate}} %
								</p>
								<p class="text">新媒体</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_zyhz_rate_diff > 0}">
									{{dz_zyhz_rate}} %
								</p>
								<p class="text">资源合作</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_wgj_rate_diff > 0}">
									{{dz_wgj_rate}} %
								</p>
								<p class="text">无轨迹</p>
							</div>
							<div class="type">
								<p class="number" :class="{active: dz_qt_rate_diff > 0}">
									{{dz_qt_rate}} %
								</p>
								<p class="text">其他</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	import axios from 'axios'
	import BScroll from 'better-scroll'
	import VFooter from '@/pages/components/v-footer'
	import {
        fallback,
        getCurrentTime,
        getDates,
        defPickerDate,
        defPickerAnchor,
        getDay,
        detailComputed
    } from '@/assets/js/_mm.js'
	export default {
		name: 'PlanHome',
		data () {
			return {
				picker: {
					data: this.defPickerDate(),
					textTitle: '月份选择',
					anchor: this.defPickerAnchor()
				},
				isDesc: false,
				isShow: false,
				nowDate : (() => {
					let y = new Date().getFullYear()
					let m = new Date().getMonth() + 1
					return y + '年' + m + '月'
				})(),
				currentYear: (() => {
				  return new Date().getFullYear()
        		})(),
				currentMonth: (() => {
				  return new Date().getMonth() + 1
        		})(),
		        currentDay: (() => {
		          return new Date().getDate()
		        })(),

		        limitDate:　(() => {
		        	return '数据截止于' + (new Date().getMonth() + 1) + '月' + new Date().getDate() + '日'
		        })(),

				currentTabIndex: 0,
				dz_total_curr: '',  //到诊实际到诊数
				dz_total_plan: '', //到诊计划数
				dh_total_curr: '',//对话实际数
				dh_total_plan: '',//对话计划数
				sure_dh_total_curr: '',//确诊对话实际数
				sure_dh_total_plan: '',//确诊对话计划数
				ys_total_curr: '',//预算实际数
				ys_total_plan: '',//预算计划数
				cb_dh_total_curr: '',//对话实际成本数
				cb_dh_total_plan: '',//对话计划成本数
				cb_sure_dh_total_curr: '',//确诊对话实际成本数
				cb_sure_dh_total_plan: '',//确诊对话计划成本数
				cb_dz_total_curr: '',//到诊实际成本数
				cb_dz_total_plan: '',//到诊计划成本数

				dz_jj_plan: '',//到诊竞价数
				dz_jj_diff: '',//到诊竞价差
				dz_yh_plan: '',//到诊优化数
				dz_yh_diff: '',//到诊优化差
				dz_mh_plan: '',//到诊门户数
				dz_mh_diff: '',//到诊门户差
				dz_xmt_plan: '',//到诊新媒体数
				dz_xmt_diff: '',//到诊新媒体差
				dz_zyhz_plan: '',//到诊资源合作数
				dz_zyhz_diff: '',//到诊资源合作差
				dz_wgj_plan: '',//到诊无轨迹数
				dz_wgj_diff: '',//到诊无轨迹差
				dz_qt_plan: '',//到诊其他数
				dz_qt_diff: '',//到诊其他差

				dh_jj_plan: '',//对话竞价数
				dh_jj_diff: '',//对话竞价差
				dh_yh_plan: '',//对话优化数
				dh_yh_diff: '',//对话优化差
				dh_mh_plan: '',//对话门户数
				dh_mh_diff: '',//对话门户差
				dh_xmt_plan: '',//对话新媒体数
				dh_xmt_diff: '',//对话新媒体差
				dh_zyhz_plan: '',//对话资源合作数
				dh_zyhz_diff: '',//对话资源合作差
				dh_wgj_plan: '',//对话无轨迹数
				dh_wgj_diff: '',//对话无轨迹差
				dh_qt_plan: '',//对话其他数
				dh_qt_diff: '',//对话其他差

				sure_dh_jj_plan: '',//确诊对话竞价数
				sure_dh_jj_diff: '',//确诊对话竞价差
				sure_dh_yh_plan: '',//确诊对话优化数
				sure_dh_yh_diff: '',//确诊对话优化差
				sure_dh_mh_plan: '',//确诊对话门户数
				sure_dh_mh_diff: '',//确诊对话门户差
				sure_dh_xmt_plan: '',//确诊对话新媒体数
				sure_dh_xmt_diff: '',//确诊对话新媒体差
				sure_dh_zyhz_plan: '',//确诊对话资源合作数
				sure_dh_zyhz_diff: '',//确诊对话资源合作差
				sure_dh_wgj_plan: '',//确诊对话无轨迹数
				sure_dh_wgj_diff: '',//确诊对话无轨迹差
				sure_dh_qt_plan: '',//确诊对话其他数
				sure_dh_qt_diff: '',//确诊对话其他差

				ys_jj_curr: '',//预算竞价数
				ys_jj_diff: '',//预算竞价差
				ys_yh_curr: '',//预算优化数
				ys_yh_diff: '',//预算优化差
				ys_mh_curr: '',//预算门户数
				ys_mh_diff: '',//预算门户差
				ys_xmt_curr: '',//预算新媒体数
				ys_xmt_diff: '',//预算新媒体差
				ys_zyhz_curr: '',//预算资源合作数
				ys_zyhz_diff: '',//预算资源合作差
				ys_wgj_curr: '',//预算无轨迹数
				ys_wgj_diff: '',//预算无轨迹差
				ys_qt_curr: '',//预算其他数
				ys_qt_diff: '',//预算其他差


				dh_jj_base: '',//对话成本竞价数
				dh_jj_base_diff: '',//对话成本竞价差
				dh_yh_base: '',//对话成本优化数
				dh_yh_base_diff: '',//对话成本优化差
				dh_mh_base: '',//对话成本门户数
				dh_mh_base_diff: '',//对话成本门户差
				dh_xmt_base: '',//对话成本新媒体数
				dh_xmt_base_diff: '',//对话成本新媒体差
				dh_zyhz_base: '',//对话成本资源合作数
				dh_zyhz_base_diff: '',//对话成本资源合作差
				dh_wgj_base: '',//对话成本无轨迹数
				dh_wgj_base_diff: '',//对话成本无轨迹差
				dh_qt_base: '',//对话成本其他数
				dh_qt_base_diff: '',//对话成本其他差

				sure_dh_jj_base: '',//确诊对话成本竞价数
				sure_dh_jj_base_diff: '',//确诊对话成本竞价差
				sure_dh_yh_base: '',//确诊对话成本优化数
				sure_dh_yh_base_diff: '',//确诊对话成本优化差
				sure_dh_mh_base: '',//确诊对话成本门户数
				sure_dh_mh_base_diff: '',//确诊对话成本门户差
				sure_dh_xmt_base: '',//确诊对话成本新媒体数
				sure_dh_xmt_base_diff: '',//确诊对话成本新媒体差
				sure_dh_zyhz_base: '',//确诊对话成本资源合作数
				sure_dh_zyhz_base_diff: '',//确诊对话成本资源合作差
				sure_dh_wgj_base: '',//确诊对话成本无轨迹数
				sure_dh_wgj_base_diff: '',//确诊对话成本无轨迹差
				sure_dh_qt_base: '',//确诊对话成本其他数
				sure_dh_qt_base_diff: '',//确诊对话成本其他差


				dz_jj_base: '',//到诊成本竞价数
				dz_jj_base_diff: '',//到诊成本竞价差
				dz_yh_base: '',//到诊成本优化数
				dz_yh_base_diff: '',//到诊成本优化差
				dz_mh_base: '',//到诊成本门户数
				dz_mh_base_diff: '',//到诊成本门户差
				dz_xmt_base: '',//到诊成本新媒体数
				dz_xmt_base_diff: '',//到诊成本新媒体差
				dz_zyhz_base: '',//到诊成本资源合作数
				dz_zyhz_base_diff: '',//到诊成本资源合作差
				dz_wgj_base: '',//到诊成本无轨迹数
				dz_wgj_base_diff: '',//到诊成本无轨迹差
				dz_qt_base: '',//到诊成本其他数
				dz_qt_base_diff: '',//到诊成本其他差

				dz_jj_rate: '',//到诊转化率竞价数
				dz_jj_rate_diff: '',//到诊转化率竞价差
				dz_yh_rate: '',//到诊转化率优化数
				dz_yh_rate_diff: '',//到诊转化率优化差
				dz_mh_rate: '',//到诊转化率门户数
				dz_mh_rate_diff: '',//到诊转化率门户差
				dz_xmt_rate: '',//到诊转化率新媒体数
				dz_xmt_rate_diff: '',//到诊转化率新媒体差
				dz_zyhz_rate: '',//到诊转化率资源合作数
				dz_zyhz_rate_diff: '',//到诊转化率资源合作差
				dz_wgj_rate: '',//到诊转化率无轨迹数
				dz_wgj_rate_diff: '',//到诊转化率无轨迹差
				dz_qt_rate: '',//到诊转化率其他数
				dz_qt_rate_diff: '',//到诊转化率其他差


				finish: ''//完成进度
			}
		},
		mounted ()　{
			this.getDetailInfo()
            this._initDetailScroll()
		},
		components: {
			VFooter
		},
		methods: {
			getDay,
			getDates,
			defPickerDate,
			defPickerAnchor,
			detailComputed,
			detailShow () {
				this.$refs.DetailSelect.show()
			},
			handleDetail (e) {
				this.nowDate = e[0]['value'] + e[1]['value']
				this.picker.anchor = e
				this.getDetailInfo(this.nowDate)
			},
			fallback,
			_initDetailScroll () {
				this.$nextTick(() => {
					this.detailScroll = new BScroll(this.$refs.detailScroll,{
						click: true,
						swipeBounceTime: 100
					})
				})
			},
			async getDetailInfo (param) {
				let month = this.nowDate.match(/(\d)+/g)
				let keepDate = getDay(-1,'-').split('-')[2]
                let keepDates =  getDates(month[1],month[0])
                let { data: planInfo } = await this.getPlanInfo();

				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_data_describe',
						hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
						time: this.nowDate.replace(/(\d+)[\D]+(\d+)[\D]+/,'$1-$2')
					}
				}).then((res) => {
					console.log(res)
					let result = res.data
					if(result.ret && result.ret === 200) {
						let data = result.data
						let dh_jj_base = isNaN(Math.round(data.dh_jj_base)) ? 0 : Math.round(data.dh_jj_base)
						let dh_yh_base = isNaN(Math.round(data.dh_yh_base)) ? 0 : Math.round(data.dh_yh_base)
						let dh_mh_base = isNaN(Math.round(data.dh_mh_base)) ? 0 : Math.round(data.dh_mh_base)
						let dh_xmt_base = isNaN(Math.round(data.dh_xmt_base)) ? 0 : Math.round(data.dh_xmt_base)
						let dh_zyhz_base = isNaN(Math.round(data.dh_zyhz_base)) ? 0 : Math.round(data.dh_zyhz_base)
						let dh_wgj_base = isNaN(Math.round(data.dh_wgj_base)) ? 0 : Math.round(data.dh_wgj_base)
						let dh_qt_base = isNaN(Math.round(data.dh_qt_base)) ? 0 : Math.round(data.dh_qt_base)
						let sure_dh_jj_base = isNaN(Math.round(data.sure_dh_jj_base)) ? 0 : Math.round(data.sure_dh_jj_base)
						let sure_dh_yh_base = isNaN(Math.round(data.sure_dh_yh_base)) ? 0 : Math.round(data.sure_dh_yh_base)
						let sure_dh_mh_base = isNaN(Math.round(data.sure_dh_mh_base)) ? 0 : Math.round(data.sure_dh_mh_base)
						let sure_dh_xmt_base = isNaN(Math.round(data.sure_dh_xmt_base)) ? 0 : Math.round(data.sure_dh_xmt_base)
						let sure_dh_zyhz_base = isNaN(Math.round(data.sure_dh_zyhz_base)) ? 0 : Math.round(data.sure_dh_zyhz_base)
						let sure_dh_wgj_base = isNaN(Math.round(data.sure_dh_wgj_base)) ? 0 : Math.round(data.sure_dh_wgj_base)
						let sure_dh_qt_base = isNaN(Math.round(data.sure_dh_qt_base)) ? 0 : Math.round(data.sure_dh_qt_base)
						let dz_jj_base = isNaN(Math.round(data.dz_jj_base)) ? 0 : Math.round(data.dz_jj_base)
						let dz_yh_base = isNaN(Math.round(data.dz_yh_base)) ? 0 : Math.round(data.dz_yh_base)
						let dz_mh_base = isNaN(Math.round(data.dz_mh_base)) ? 0 : Math.round(data.dz_mh_base)
						let dz_xmt_base = isNaN(Math.round(data.dz_xmt_base)) ? 0 : Math.round(data.dz_xmt_base)
						let dz_zyhz_base = isNaN(Math.round(data.dz_zyhz_base)) ? 0 : Math.round(data.dz_zyhz_base)
						let dz_wgj_base = isNaN(Math.round(data.dz_wgj_base)) ? 0 : Math.round(data.dz_wgj_base)
						let dz_qt_base = isNaN(Math.round(data.dz_qt_base)) ? 0 : Math.round(data.dz_qt_base)
						let dz_jj_rate = isNaN(Math.round(data.dz_jj_rate)) ? 0 : Math.round(data.dz_jj_rate)
						let dz_yh_rate = isNaN(Math.round(data.dz_yh_rate)) ? 0 : Math.round(data.dz_yh_rate)
						let dz_mh_rate = isNaN(Math.round(data.dz_mh_rate)) ? 0 : Math.round(data.dz_mh_rate)
						let dz_xmt_rate = isNaN(Math.round(data.dz_xmt_rate)) ? 0 : Math.round(data.dz_xmt_rate)
						let dz_zyhz_rate = isNaN(Math.round(data.dz_zyhz_rate)) ? 0 : Math.round(data.dz_zyhz_rate)
						let dz_wgj_rate = isNaN(Math.round(data.dz_wgj_rate)) ? 0 : Math.round(data.dz_wgj_rate)
						let dz_qt_rate = isNaN(Math.round(data.dz_qt_rate)) ? 0 : Math.round(data.dz_qt_rate)
			
						let ys_total_curr = isNaN(Math.round(data.ys_total_curr)) ? '' : Math.round(data.ys_total_curr)
						let cb_dh_total_curr = isNaN(Math.round(data.cb_dh_total_curr)) ? '' : Math.round(data.cb_dh_total_curr)
						let cb_sure_dh_total_curr = isNaN(Math.round(data.cb_sure_dh_total_curr)) ? '' : Math.round(data.cb_sure_dh_total_curr)
						let cb_dz_total_curr = isNaN(Math.round(data.cb_dz_total_curr)) ? '' : Math.round(data.cb_dz_total_curr)

						this.dz_total_curr = data.dz_total_curr //到诊实际到诊数
						this.dz_total_plan =  data.dz_total_plan //到诊计划数
						this.dh_total_curr = data.dh_total_curr//对话实际数
						this.dh_total_plan =  data.dh_total_plan//对话计划数
						this.sure_dh_total_curr = data.sure_dh_total_curr//确诊对话实际数
						this.sure_dh_total_plan =  data.sure_dh_total_plan//确诊对话计划数
						this.ys_total_curr = ys_total_curr//预算实际数
						this.ys_total_plan = data.ys_total_plan//预算计划数
						this.cb_dh_total_curr = cb_dh_total_curr//对话实际成本数
						this.cb_dh_total_plan = data.cb_dh_total_plan//对话计划成本数
						this.cb_sure_dh_total_plan = data.cb_sure_dh_total_plan//对话计划成本数
						this.cb_sure_dh_total_curr = cb_sure_dh_total_curr // 确诊对话实际成本
						this.cb_dz_total_curr = cb_dz_total_curr//到诊实际成本数
						this.cb_dz_total_plan = data.cb_dz_total_plan//到诊计划成本数
						

						this.dz_jj_plan = data.dz_jj_plan//到诊竞价数
						this.dz_jj_diff = data.dz_jj_plan - this.detailComputed(planInfo.jj_in_count, month)//到诊竞价差
						this.dz_yh_plan = data.dz_yh_plan//到诊优化数
            this.dz_yh_diff = data.dz_yh_plan - this.detailComputed(planInfo.yh_in_count, month)//到诊优化差
						this.dz_mh_plan = data.dz_mh_plan//到诊门户数
						this.dz_mh_diff = data.dz_mh_plan - this.detailComputed(planInfo.mh_in_count, month)//到诊门户差
						this.dz_xmt_plan = data.dz_xmt_plan//到诊新媒体数
						this.dz_xmt_diff = data.dz_xmt_plan - this.detailComputed(planInfo.xmt_in_count, month)//到诊新媒体差
						this.dz_zyhz_plan = data.dz_zyhz_plan//到诊资源合作数
						this.dz_zyhz_diff = data.dz_zyhz_plan - this.detailComputed(planInfo.zyhz_in_count, month)//到诊资源合作差
						this.dz_wgj_plan = data.dz_wgj_plan//到诊无轨迹数
						this.dz_wgj_diff = data.dz_wgj_plan - this.detailComputed(planInfo.wgj_in_count, month)//到诊无轨迹差
						this.dz_qt_plan = data.dz_qt_plan//到诊其他数
						this.dz_qt_diff = data.dz_qt_plan - this.detailComputed(planInfo.qt_in_count, month)//到诊其他差

						this.dh_jj_plan = data.dh_jj_plan//对话竞价数
            this.dh_jj_diff = data.dh_jj_plan - this.detailComputed(planInfo.jj_dialog_count, month)//对话竞价差
						this.dh_yh_plan = data.dh_yh_plan//对话优化数
            this.dh_yh_diff = data.dh_yh_plan - this.detailComputed(planInfo.yh_dialog_count, month)//对话优化差
						this.dh_mh_plan = data.dh_mh_plan//对话门户数
						this.dh_mh_diff = data.dh_mh_plan - this.detailComputed(planInfo.mh_dialog_count, month)//对话门户差
						this.dh_xmt_plan = data.dh_xmt_plan//对话新媒体数
						this.dh_xmt_diff = data.dh_xmt_plan - this.detailComputed(planInfo.xmt_dialog_count, month)//对话新媒体差
						this.dh_zyhz_plan = data.dh_zyhz_plan//对话资源合作数
						this.dh_zyhz_diff = data.dh_zyhz_plan - this.detailComputed(planInfo.zyhz_dialog_count, month)//对话资源合作差
						this.dh_wgj_plan = data.dh_wgj_plan//对话无轨迹数
						this.dh_wgj_diff = data.dh_wgj_plan - this.detailComputed(planInfo.wgj_dialog_count, month)//对话无轨迹差
						this.dh_qt_plan = data.dh_qt_plan//对话其他数
						this.dh_qt_diff = data.dh_qt_plan - this.detailComputed(planInfo.qt_dialog_count, month)//对话其他差

						this.sure_dh_jj_plan = data.sure_dh_jj_plan//确诊对话竞价数
            this.sure_dh_jj_diff = data.sure_dh_jj_plan - this.detailComputed(planInfo.jj_dialog_count, month)//确诊对话竞价差
						this.sure_dh_yh_plan = data.sure_dh_yh_plan//确诊对话优化数
            this.sure_dh_yh_diff = data.sure_dh_yh_plan - this.detailComputed(planInfo.yh_dialog_count, month)//确诊对话优化差
						this.sure_dh_mh_plan = data.sure_dh_mh_plan//确诊对话门户数
						this.sure_dh_mh_diff = data.sure_dh_mh_plan - this.detailComputed(planInfo.mh_dialog_count, month)//确诊对话门户差
						this.sure_dh_xmt_plan = data.sure_dh_xmt_plan//确诊对话新媒体数
						this.sure_dh_xmt_diff = data.sure_dh_xmt_plan - this.detailComputed(planInfo.xmt_dialog_count, month)//确诊对话新媒体差
						this.sure_dh_zyhz_plan = data.sure_dh_zyhz_plan//确诊对话资源合作数
						this.sure_dh_zyhz_diff = data.sure_dh_zyhz_plan - this.detailComputed(planInfo.zyhz_dialog_count, month)//确诊对话资源合作差
						this.sure_dh_wgj_plan = data.sure_dh_wgj_plan//确诊对话无轨迹数
						this.sure_dh_wgj_diff = data.sure_dh_wgj_plan - this.detailComputed(planInfo.wgj_dialog_count, month)//确诊对话无轨迹差
						this.sure_dh_qt_plan = data.sure_dh_qt_plan//确诊对话其他数
						this.sure_dh_qt_diff = data.sure_dh_qt_plan - this.detailComputed(planInfo.qt_dialog_count, month)//确诊对话其他差

						this.ys_jj_curr = Math.round(data.ys_jj_curr)//预算竞价数
            this.ys_jj_diff = data.ys_jj_curr - this.detailComputed(planInfo.jj_order_price, month)//预算竞价差
						this.ys_yh_curr = Math.round(data.ys_yh_curr)//预算优化数
            this.ys_yh_diff = data.ys_yh_curr - this.detailComputed(planInfo.yh_order_price, month)//预算优化差
						this.ys_mh_curr = Math.round(data.ys_mh_curr),//预算门户数
						this.ys_mh_diff = data.ys_mh_curr - this.detailComputed(planInfo.mh_order_price, month)//预算门户差
						this.ys_xmt_curr = Math.round(data.ys_xmt_curr),//预算新媒体数
						this.ys_xmt_diff = data.ys_xmt_curr - this.detailComputed(planInfo.xmt_order_price, month)//预算新媒体差
						this.ys_zyhz_curr = Math.round(data.ys_zyhz_curr),//预算资源合作数
						this.ys_zyhz_diff = data.ys_zyhz_curr - this.detailComputed(planInfo.zyhz_order_price, month)//预算资源合作差
						this.ys_wgj_curr = Math.round(data.ys_wgj_curr),//预算无轨迹数
						this.ys_wgj_diff = data.ys_wgj_curr - this.detailComputed(planInfo.wgj_order_price, month)//预算无轨迹差
						this.ys_qt_curr = Math.round(data.ys_qt_curr)//预算其他数
						this.ys_qt_diff = data.ys_qt_curr - this.detailComputed(planInfo.qt_order_price, month)//预算其他差

						this.dh_jj_base = dh_jj_base//对话成本竞价数
						this.dh_jj_base_diff = dh_jj_base - planInfo.jj_dialog_base//对话成本竞价差
						this.dh_yh_base = dh_yh_base//对话成本优化数
						this.dh_yh_base_diff = dh_yh_base - planInfo.yh_dialog_base//对话成本优化差
						this.dh_mh_base =dh_mh_base//对话成本门户数
						this.dh_mh_base_diff = dh_mh_base - planInfo.mh_dialog_base//对话成本门户差
						this.dh_xmt_base = dh_xmt_base//对话成本新媒体数
						this.dh_xmt_base_diff = dh_xmt_base - planInfo.xmt_dialog_base//对话成本新媒体差
						this.dh_zyhz_base = dh_zyhz_base//对话成本资源合作数
						this.dh_zyhz_base_diff = dh_zyhz_base - planInfo.zyhz_dialog_base//对话成本资源合作差
						this.dh_wgj_base = dh_wgj_base//对话成本无轨迹数
						this.dh_wgj_base_diff = dh_wgj_base - planInfo.wgj_dialog_base//对话成本无轨迹差
						this.dh_qt_base = dh_qt_base//对话成本其他数
						this.dh_qt_base_diff = dh_qt_base - planInfo.qt_dialog_base//对话成本其他差

						this.sure_dh_jj_base = sure_dh_jj_base//确诊对话成本竞价数
						this.sure_dh_jj_base_diff = sure_dh_jj_base - planInfo.jj_dialog_base//确诊对话成本竞价差
						this.sure_dh_yh_base = sure_dh_yh_base//确诊对话成本优化数
						this.sure_dh_yh_base_diff = sure_dh_yh_base - planInfo.yh_dialog_base//确诊对话成本优化差
						this.sure_dh_mh_base =sure_dh_mh_base//确诊对话成本门户数
						this.sure_dh_mh_base_diff = sure_dh_mh_base - planInfo.mh_dialog_base//确诊对话成本门户差
						this.sure_dh_xmt_base = sure_dh_xmt_base//确诊对话成本新媒体数
						this.sure_dh_xmt_base_diff = sure_dh_xmt_base - planInfo.xmt_dialog_base//确诊对话成本新媒体差
						this.sure_dh_zyhz_base = sure_dh_zyhz_base//确诊对话成本资源合作数
						this.sure_dh_zyhz_base_diff = sure_dh_zyhz_base - planInfo.zyhz_dialog_base//确诊对话成本资源合作差
						this.sure_dh_wgj_base = sure_dh_wgj_base//确诊对话成本无轨迹数
						this.sure_dh_wgj_base_diff = sure_dh_wgj_base - planInfo.wgj_dialog_base//确诊对话成本无轨迹差
						this.sure_dh_qt_base = sure_dh_qt_base//确诊对话成本其他数
						this.sure_dh_qt_base_diff = sure_dh_qt_base - planInfo.qt_dialog_base//确诊对话成本其他差

						this.dz_jj_base = dz_jj_base//到诊成本竞价数
						this.dz_jj_base_diff = dz_jj_base - planInfo.jj_in_base//到诊成本竞价差
						this.dz_yh_base = dz_yh_base//到诊成本优化数
						this.dz_yh_base_diff = dz_yh_base - planInfo.yh_in_base//到诊成本优化差
						this.dz_mh_base = dz_mh_base//到诊成本门户数
						this.dz_mh_base_diff = dz_mh_base - planInfo.mh_in_base//到诊成本门户差
						this.dz_xmt_base = dz_xmt_base//到诊成本新媒体数
						this.dz_xmt_base_diff = dz_xmt_base - planInfo.xmt_in_base//到诊成本新媒体差
						this.dz_zyhz_base = dz_zyhz_base//到诊成本资源合作数
						this.dz_zyhz_base_diff = dz_zyhz_base - planInfo.zyhz_in_base//到诊成本资源合作差
						this.dz_wgj_base = dz_wgj_base//到诊成本无轨迹数
						this.dz_wgj_base_diff = dz_wgj_base - planInfo.wgj_in_base//到诊成本无轨迹差
						this.dz_qt_base = dz_qt_base//到诊成本其他数
						this.dz_qt_base_diff = dz_qt_base - planInfo.qt_in_base//到诊成本其他差

						this.dz_jj_rate = Math.round((data.dz_jj_plan / data.dh_jj_plan) * 100).toFixed(2)//到诊转化率竞价数
						this.dz_jj_rate = isNaN(this.dz_jj_rate) ? 0 : this.dz_jj_rate
						this.dz_jj_rate = this.dz_jj_rate == 'Infinity' ? '-' : this.dz_jj_rate
						this.dz_jj_rate_diff = dz_jj_rate - planInfo.jj_in_rate//到诊转化率竞价差
						this.dz_yh_rate = Math.round((data.dz_yh_plan / data.dh_yh_plan) * 100).toFixed(2)//到诊转化率优化数
						this.dz_yh_rate = isNaN(this.dz_yh_rate) ? 0 : this.dz_yh_rate
						this.dz_yh_rate = this.dz_yh_rate == 'Infinity' ? '-' : this.dz_yh_rate
						this.dz_yh_rate_diff = dz_yh_rate - planInfo.yh_in_rate//到诊转化率优化差
						this.dz_mh_rate = Math.round((data.dz_mh_plan / data.dh_mh_plan) * 100).toFixed(2)//到诊转化率门户数
						this.dz_mh_rate = isNaN(this.dz_mh_rate) ? 0 : this.dz_mh_rate
						this.dz_mh_rate = this.dz_mh_rate == 'Infinity' ? '-' : this.dz_mh_rate
						this.dz_mh_rate_diff = dz_mh_rate - planInfo.mh_in_rate//到诊转化率门户差
						this.dz_xmt_rate = Math.round((data.dz_xmt_plan / data.dh_xmt_plan) * 100).toFixed(2)//到诊转化率新媒体数
						this.dz_xmt_rate = isNaN(this.dz_xmt_rate) ? 0 : this.dz_xmt_rate
						this.dz_xmt_rate = this.dz_xmt_rate == 'Infinity' ? '-' : this.dz_xmt_rate
						this.dz_xmt_rate_diff = dz_xmt_rate - planInfo.xmt_in_rate//到诊转化率新媒体差
						this.dz_zyhz_rate = Math.round((data.dz_zyhz_plan / data.dh_zyhz_plan) * 100).toFixed(2)//到诊转化率资源合作数
						this.dz_zyhz_rate = isNaN(this.dz_zyhz_rate) ? 0 : this.dz_zyhz_rate
						this.dz_zyhz_rate = this.dz_zyhz_rate == 'Infinity' ? '-' : this.dz_zyhz_rate
						this.dz_zyhz_rate_diff = dz_zyhz_rate - planInfo.zyhz_in_rate//到诊转化率资源合作差
						this.dz_wgj_rate = Math.round((data.dz_wgj_plan / data.dh_wgj_plan) * 100).toFixed(2)//到诊转化率无轨迹数
						this.dz_wgj_rate = isNaN(this.dz_wgj_rate) ? 0 : this.dz_wgj_rate
						this.dz_wgj_rate = this.dz_wgj_rate == 'Infinity' ? '-' : this.dz_wgj_rate
						this.dz_wgj_rate_diff = dz_wgj_rate - planInfo.wgj_in_rate//到诊转化率无轨迹差
						this.dz_qt_rate = Math.round((data.dz_qt_plan / data.dh_qt_plan) * 100).toFixed(2)//到诊转化率其他数
						this.dz_qt_rate = isNaN(this.dz_qt_rate) ? 0 : this.dz_qt_rate
						this.dz_qt_rate = this.dz_qt_rate == 'Infinity' ? '-' : this.dz_qt_rate
						this.dz_qt_rate_diff = dz_qt_rate - planInfo.qt_in_rate//到诊转化率其他差


						this.finish = data.finish//完成进度

						if(this.currentYear == month[0] && this.currentMonth == month[1]) {
							this.limitDate = '数据截止于' + this.nowDate + keepDate + '日'
							if((new Date().getDate()) != 1) {
								this.dz_total_plan =  (data.dz_total_plan * keepDate) ? (data.dz_total_plan * keepDate) : ''//到诊计划数
								this.dh_total_plan =  (data.dh_total_plan * keepDate) ? (data.dh_total_plan * keepDate) : ''//对话计划数
								this.sure_dh_total_plan =  (data.sure_dh_total_plan * keepDate) ? (data.sure_dh_total_plan * keepDate) : ''//确诊对话计划数
								this.ys_total_plan = (data.ys_total_plan * keepDate) ? (data.ys_total_plan * keepDate) : ''//预算计划数
							}
						} else {
							this.limitDate = '数据截止于' + this.nowDate
							this.dz_total_plan =  (data.dz_total_plan * keepDates) ? (data.dz_total_plan * keepDates) : '' //到诊计划数
							this.dh_total_plan =  (data.dh_total_plan * keepDates) ? (data.dh_total_plan * keepDates) : ''//对话计划数
							this.sure_dh_total_plan =  (data.sure_dh_total_plan * keepDates) ? (data.sure_dh_total_plan * keepDates) : ''//确诊对话计划数
							this.ys_total_plan = (data.ys_total_plan * keepDates) ? (data.ys_total_plan * keepDates) : ''//预算计划数
						}
						if (Object.keys(data).length > 0) {
							this.isShow = true
						}else{
							this.isShow = false
						}
						this._initDetailScroll()
					}
				})
				},
				getPlanInfo () {
					let res = axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_month_plan',
						hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
						time: this.nowDate.replace(/(\d+)[\D]+(\d+)[\D]+/,'$1-$2')
					}
				}).then( ({ data }) => {
						if(data.ret === 200) {
								return data
							}
						}).catch(error => {
							console.log(error)
						})
						return res
					}
        },
		computed: {
			progress () {
				if(this.dz_total_curr !== undefined && this.dz_total_plan !== undefined) {
					let keep = this.dz_total_curr - this.dz_total_plan
					keep >= 0 ? '+' + keep : keep
					return keep
				} else {
					return ''
				}
			},
			dz_state () {
				if (this.dz_total_curr < this.dz_total_plan) {
					let keep = this.dz_total_plan - this.dz_total_curr
					return '差' + keep + '人'
				}else {
					return '已完成'
				}
			},
			dh_state () {
				if (this.dh_total_curr < this.dh_total_plan) {
					let keep = this.dh_total_plan - this.dh_total_curr
					return '差' + keep + '条'
				}else {
					return '已完成'
				}
			},
			sure_dh_state () {
				if (this.sure_dh_total_curr < this.sure_dh_total_plan) {
					let keep = this.sure_dh_total_plan - this.sure_dh_total_curr
					return '差' + keep + '条'
				}else {
					return '已完成'
				}
			},
			ys_state () {
				if (this.ys_total_curr > this.ys_total_plan) {
					let keep = (this.ys_total_curr - this.ys_total_plan).toFixed(0)
					return '已超出' + keep + '元'
				}else {
					return '正常'
				}
			},
			dh_base_state () {
				if (this.cb_dh_total_curr > this.cb_dh_total_plan) {
					let keep = (this.cb_dh_total_curr - this.cb_dh_total_plan).toFixed(0)
					return '已超出' + keep + '元'
				}else {
					return '正常'
				}
			},
			sure_dh_base_state () {
				if (this.cb_sure_dh_total_curr > this.cb_sure_dh_total_plan) {
					let keep = (this.cb_sure_dh_total_curr - this.cb_sure_dh_total_plan).toFixed(0)
					return '已超出' + keep + '元'
				}else {
					return '正常'
				}
			},
			dz_base_state () {
				if (this.cb_dz_total_curr > this.cb_dz_total_plan) {
					let keep = (this.cb_dz_total_curr - this.cb_dz_total_plan).toFixed(0)
					return '已超出' + keep + '元'
				}else {
					return '正常'
				}
			}
		}

	}
</script>

<style lang="stylus" scoped>
	.detail-wrapper
		width: 100%
		height: 100%
		background-color: #f2f2f2
		.header
			display: flex
			justify-content: space-between
			height: 1.1rem
			padding: 0 .2rem 0 .4rem
			background-color: #ffffff
			.header-title
				line-height: 1.1rem
				color: #1d1d1d
				font-size: 0
				.back
					display: inline-block
					width: .64rem
					font-size: .42rem
					.iconfont
						vertical-align: middle
						font-size: .42rem
						font-weight: bold
				.title
					font-size: .3rem
			.header-select
				.select-wrapper
					display: inline-block
					font-size: 0
					.select
						box-sizing: border-box
						display: inline-block
						vertical-align: top
						height: .58rem
						padding: 0 .24rem
						line-height: .58rem
						font-size: .28rem
						text-align: center
						border: 1px solid #666666
						border-right: none
					.icon-wrapper
						box-sizing: border-box
						display: inline-block
						vertical-align: top
						width: .48rem
						height: .58rem
						line-height: .58rem
						text-align: center
						border: 1px solid #666666
						.select-icon
							font-size: .28rem
		.contant-wrapper
			position: absolute
			left: 0
			right: 0
			top: 1.1rem
			bottom: 1.1rem
			z-index: 10
			overflow: hidden
			.desc-wrap
				padding: .4rem .3rem
				background-color: #39f
				&.desc-l
					background-color: #f60
				&.desc-c
					background-color: #67c23a
				.title
					color: #d6ebff
					font-size: .24rem
				.content
					display: flex
					flex-direction: column
					align-items: center
					justify-content: center
					box-sizing: border-box
					width: 2.4rem
					height: 2.4rem
					margin: auto
					color: #ffffff
					font-size: .48rem
					.desc
						margin-bottom: .24rem
			.detail-list
				.list-item
					padding: .3rem
					background-color: #ffffff
					&+.list-item
						margin-top: .24rem
					.item-head
						font-size: 0
						height: .48rem
						line-height: .48rem
						.text
							margin-right: .1rem
							color: #3399ff
							font-size: 0.3rem
							.icon-round
								margin-right: .12rem
						.number
							color: #8695b9
							font-size: .3rem
							.col
								color: #39f
						.state
							float: right
							padding: 0 .24rem
							height: .48rem
							color: #ff6600
							font-size: .24rem
							text-align: center
							border: 1px solid #ff6600
							border-radius: .24rem
							&.active
								color: #3399ff
								border: 1px solid #3399ff
							&.active-color
								color: #f60
								border: 1px solid #f60
					.item-content
						display: flex
						margin-top: .3rem
						flex-wrap: wrap
						height: 1.9rem
						.type
							text-align: center
							width: 1.7rem
							margin-bottom: .4rem
							.number
								position: relative
								color: #666666
								font-size: .36rem
								&.active
									color: #f60
								.tips
									position: absolute
									// right: .16rem
									top: -.16rem
									font-size: .24rem
									&.glide
										color: #ff3300
									&.rise
										color: #33cc00
							.text
								margin-top: .16rem
								color: #999999
								font-size: .24rem
</style>



// WEBPACK FOOTER //
// src/pages/detail/detail.vue